import _ from 'lodash';
import logger from './logger';
import nativeUtility from './nativeUtility';
import utility from './utility';

// utility used by the mobile team to track random metrics that shouldn't go into Google Analytics
const nativeAnalytics = {
    // Check if native analytics are disabled
    isDisabled() {
        // checks isNativeMobileRequest + window.Android
        return (
            !nativeUtility.isNativeAndModuleDefined() ||
            utility.isNativeVrbexWebview()
        );
    },

    isEnabled() {
        return !this.isDisabled();
    },

    trackPage(pageName) {
        if (this.isDisabled()) {
            return;
        }

        // https://github.homeawaycorp.com/MobileApps/iOS-Traveler/blob/master/HomeAway/HAResources-iOS/webview/webview-analytics.js
        if (typeof window.Android.trackPage === 'function') {
            window.Android.trackPage(pageName);
        }
    },

    trackEvent(event) {
        if (this.isDisabled()) {
            return;
        }

        this.trackEventWithProperties(event, {});
    },

    trackEventWithProperties(event, properties) {
        if (this.isDisabled()) {
            return;
        }

        let mpp;
        if (!utility.isNativeMobileIOS()) {
            mpp = {};
        }
        try {
            properties = _.extend(properties, mpp);
            let json = _.isEmpty(properties)
                ? 'no properties'
                : JSON.stringify(properties, null, 4);
            logger.log(`Mixpanel: ${event}\n${json}`);
            // https://github.homeawaycorp.com/MobileApps/iOS-Traveler/blob/master/HomeAway/HAResources-iOS/webview/webview-analytics.js
            if (typeof window.Android.trackEventWithProperties === 'function') {
                window.Android.trackEventWithProperties(event, properties);
            }
        } catch (error) {
            logger.log(`Mixpanel error: ${error}`);
        }
    },

    trackPicketlineEvent(event, properties = {}) {
        if (this.isDisabled() || !event || typeof event !== 'string') {
            return;
        }

        // https://github.homeawaycorp.com/MobileApps/iOS-Traveler/blob/master/HomeAway/HAResources-iOS/webview/webview-analytics.js
        if (typeof window.Android.trackPicketlineEvent === 'function') {
            window.Android.trackPicketlineEvent(event, properties);
        }
    },

    bookingRequestSubmitted() {
        if (this.isDisabled()) {
            return;
        }

        if (typeof window.Android.trackEventWithProperties === 'function') {
            window.Android.trackEventWithProperties('generic.event', {
                eventcategory: 'traveler checkout',
                eventaction: 'reservation validation success',
                source: 'billing_info',
            });
        }
    },
};

export default nativeAnalytics;
